// Telechargement des documents joints a une operation (table documents : CMR,
// INVOICE, AVIZ… envoyes par « Upload document »). Le fichier garde sur le
// serveur l'extension de l'original, qui n'est pas toujours un PDF : un CMR
// photographie au telephone est un .jpeg. La page Transport l'enregistrait
// pourtant sous « CMR.PDF » (le lecteur PDF refusait de l'ouvrir) et les autres
// pages sous « CMR », sans extension.
//
// Le type est lu dans les premiers octets du fichier, pas dans l'URL : les
// anciens envois ont des extensions fausses (« ….03 » quand le nom d'origine
// contenait un point, ex. « CMR 12.03.pdf » coupe au premier point).

const SIGNATURES = [
  { ext: "pdf", type: "application/pdf", bytes: [0x25, 0x50, 0x44, 0x46] }, // %PDF
  { ext: "jpg", type: "image/jpeg", bytes: [0xff, 0xd8, 0xff] },
  { ext: "png", type: "image/png", bytes: [0x89, 0x50, 0x4e, 0x47] },
  { ext: "gif", type: "image/gif", bytes: [0x47, 0x49, 0x46, 0x38] },
  { ext: "tif", type: "image/tiff", bytes: [0x49, 0x49, 0x2a, 0x00] },
  { ext: "tif", type: "image/tiff", bytes: [0x4d, 0x4d, 0x00, 0x2a] },
];

// Conteneurs dont l'extension precise ne se lit pas dans l'en-tete : on garde
// celle de l'URL si elle correspond a la famille.
const ZIP_EXTS = ["docx", "xlsx", "pptx", "odt", "ods", "zip"];
const OLE_EXTS = ["doc", "xls", "ppt", "msg"];

function startsWith(head, bytes, offset = 0) {
  return bytes.every((b, i) => head[offset + i] === b);
}

function urlExtension(url) {
  const match = /\.([a-z0-9]{2,5})(?:[?#].*)?$/i.exec(url || "");
  // « .03 », « .052024 » : morceau de nom, pas une extension.
  return match && /[a-z]/i.test(match[1]) ? match[1].toLowerCase() : "";
}

/** Extension et type MIME reels d'un fichier telecharge. */
export function detectDocumentType(data, url) {
  const head = new Uint8Array(data instanceof ArrayBuffer ? data.slice(0, 16) : []);
  const known = SIGNATURES.find((s) => startsWith(head, s.bytes));
  if (known) return { ext: known.ext, type: known.type };

  const fromUrl = urlExtension(url);
  // HEIC / HEIF (photos iPhone) : « ftyp » a l'octet 4.
  if (startsWith(head, [0x66, 0x74, 0x79, 0x70], 4)) {
    return { ext: fromUrl === "heif" ? "heif" : "heic", type: "image/heic" };
  }
  if (startsWith(head, [0x50, 0x4b, 0x03, 0x04])) {
    return { ext: ZIP_EXTS.includes(fromUrl) ? fromUrl : "zip", type: "application/zip" };
  }
  if (startsWith(head, [0xd0, 0xcf, 0x11, 0xe0])) {
    return { ext: OLE_EXTS.includes(fromUrl) ? fromUrl : "doc", type: "application/octet-stream" };
  }
  return { ext: fromUrl, type: "application/octet-stream" };
}

/**
 * Enregistre le fichier sous « <title>.<vraie extension> ». `data` est la
 * reponse axios en responseType "arraybuffer", `url` celle du document.
 */
export function saveDownloadedDocument(data, title, url) {
  const { ext, type } = detectDocumentType(data, url);
  let filename = String(title || "document").trim() || "document";
  if (ext && !filename.toLowerCase().endsWith("." + ext)) filename += "." + ext;

  const href = window.URL.createObjectURL(new Blob([data], { type }));
  const link = document.createElement("a");
  link.href = href;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  setTimeout(() => window.URL.revokeObjectURL(href), 1000);
}
